import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote, ChevronLeft, ChevronRight, PlayCircle } from 'lucide-react';
import { testimonials } from '../data/testimonials'; // Assuming this exists, or I'll use inline data if needed
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Fallback data if import fails or is empty
  const data = testimonials?.length > 0 ? testimonials : [{
    id: 1,
    name: 'Laura Martínez',
    role: 'Dueña de Max',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200',
    petImage: 'https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&q=80&w=200',
    text: 'Desde que cambiamos a Petiora, las alergias de Max desaparecieron por completo. Su pelaje brilla y tiene más energía que nunca. ¡Increíble!',
    rating: 5,
    product: 'Plan Personalizado'
  }, {
    id: 2,
    name: 'Carlos Ruiz',
    role: 'Dueño de Luna',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
    petImage: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&q=80&w=200',
    text: 'La calculadora nutricional fue un descubrimiento. Ahora sé exactamente qué necesita Luna y ella adora el sabor. El servicio al cliente es de 10.',
    rating: 5,
    product: 'Menú de Pollo'
  }, {
    id: 3,
    name: 'Ana García',
    role: 'Veterinaria',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200',
    petImage: 'https://images.unsplash.com/photo-1537151608828-ea2b11777ee8?auto=format&fit=crop&q=80&w=200',
    text: 'Como profesional, recomiendo Petiora por su transparencia en ingredientes y formulación científica. Es nutrición real, no marketing.',
    rating: 5,
    product: 'Suplementos'
  }];
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % data.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + data.length) % data.length);
  };
  return <section id="testimonios" className="py-24 bg-charcoal-900 text-white relative overflow-hidden" data-id="element-4753">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" data-id="element-4754" />

      <div className="container-custom max-w-7xl mx-auto relative z-10" data-id="element-4755">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-4756">
          {/* Left: Heading & Controls */}
          <div data-id="element-4757">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-sm font-bold mb-8 backdrop-blur-sm" data-id="element-4758">
              <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-4759" />
              <span data-id="element-4760">Historias de Éxito</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-4761">
              Más que comida, <br data-id="element-4762" />
              <span className="text-primary-400" data-id="element-4763">resultados visibles</span>
            </h2>

            <p className="text-gray-300 text-lg mb-10 leading-relaxed max-w-md font-light" data-id="element-4764">
              Únete a las miles de familias que han transformado la salud de sus
              mascotas. Nutrición real, resultados reales.
            </p>

            <div className="flex gap-4" data-id="element-4765">
              <button onClick={prev} className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-charcoal-900 transition-all duration-300 group" aria-label="Anterior testimonio" data-id="element-4766">
                <ChevronLeft className="w-6 h-6 group-hover:-translate-x-1 transition-transform" data-id="element-4767" />
              </button>
              <button onClick={next} className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-charcoal-900 transition-all duration-300 group" aria-label="Siguiente testimonio" data-id="element-4768">
                <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-4769" />
              </button>
            </div>
          </div>

          {/* Right: Testimonial Card */}
          <div className="relative" data-id="element-4770">
            <AnimatePresence mode="wait" data-id="element-4771">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.5,
              ease: 'easeInOut'
            }} className="bg-white rounded-[2.5rem] p-8 md:p-12 text-charcoal-900 shadow-2xl relative" data-id="element-4772">
                <Quote className="absolute top-8 right-8 w-12 h-12 text-primary-100 rotate-180" data-id="element-4773" />

                <div className="flex items-center gap-4 mb-8" data-id="element-4774">
                  <div className="relative" data-id="element-4775">
                    <img src={data[currentIndex].image} alt={data[currentIndex].name} className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg" data-id="element-4776" />
                    <img src={data[currentIndex].petImage} alt="Mascota" className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-md absolute -bottom-2 -right-2" data-id="element-4777" />
                  </div>
                  <div data-id="element-4778">
                    <h4 className="font-bold text-lg" data-id="element-4779">
                      {data[currentIndex].name}
                    </h4>
                    <p className="text-sm text-charcoal-500" data-id="element-4780">
                      {data[currentIndex].role}
                    </p>
                  </div>
                </div>

                <div className="flex gap-1 mb-6" data-id="element-4781">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-4782" />)}
                </div>

                <p className="text-xl md:text-2xl font-serif leading-relaxed mb-8" data-id="element-4783">
                  "{data[currentIndex].text}"
                </p>

                <div className="flex items-center justify-between pt-8 border-t border-gray-100" data-id="element-4784">
                  <div className="text-sm font-bold text-primary-700 bg-primary-50 px-3 py-1 rounded-full" data-id="element-4785">
                    {data[currentIndex].product}
                  </div>

                  <button className="text-sm font-bold text-charcoal-400 hover:text-primary-600 flex items-center gap-2 transition-colors" data-id="element-4786">
                    <PlayCircle className="w-4 h-4" data-id="element-4787" /> Ver video historia
                  </button>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Decorative Elements behind card */}
            <div className="absolute -z-10 top-4 -right-4 w-full h-full bg-primary-800/50 rounded-[2.5rem]" data-id="element-4788" />
            <div className="absolute -z-20 top-8 -right-8 w-full h-full bg-primary-900/30 rounded-[2.5rem]" data-id="element-4789" />
          </div>
        </div>
      </div>
    </section>;
}